import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';



import Divider from '@material-ui/core/Divider';

import { Link } from 'react-router-dom';

import BackIcon from '@material-ui/icons/ChevronLeft';
import { Redirect } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import ChallengeComp from "../components/ChallengeComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import * as STATIC from '../config/static';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import TopBar from '../components/TopBar';





let _this;

const DWIDTH = 980;

class Challenges extends Component {
  constructor() {
    super();
    _this = this;
    this.state = { wWidth: 0, wHeight: 0,rankLevel:'easy', message: '',showRank:false,showResult:false,showLevel:false,showType:false,ranks:false,curType:false,curLevel:false,showChallenge:false,challenge:false,curChallenge:false,result:{}};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });


  }

  componentDidMount() {
    this.loadChallenge();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);


  this.setState({  loading: false });

  }
  async loadChallenge()
  {
    let doc =  await firebase.firestore().collection("challenges").doc('challenge').get();
    if(doc.exists)
    {
      let newItem = doc.data();

      _this.setState({challenge:newItem});
    }
  }

  componentWillUnmount() {

    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }



onChallengeEnd(questions) {
  //console.log(questions);
  let count = 0;
  let countCorrect = 0;
  for (let q of questions) {
    if (q.status) {
      count++;
      if (q.status == 1) {
        countCorrect++;
      }
    }
  }

  // if(count==countCorrect&&count==questions.length)
  // {
  //   _this.setState({showSignUp:true});
  // }
  let isPass = false;

  if(questions.curPoint>=questions.point_pass)
  {
    isPass = true;
  }
  let ACCOUNT = store.getState().ACCOUNT;
  let nResult = {questions,countCorrect,qlength: questions.length};
  if(ACCOUNT.type==0)

  {
    nResult.id_student=ACCOUNT.id;
    nResult.name=ACCOUNT.ten;
    nResult.idchinhanh = ACCOUNT.idchinhanh;
    nResult.challenge_point = questions.curPoint;
    nResult.level = _this.state.curLevel;
    let key = JSON.stringify({id:ACCOUNT.id,time:(new Date().getTime())});
    nResult.key = STATIC.encryptStringWithRsaPublicKey(key);
    _this.postResultToServer(nResult);
  }
  //  _this.postResultToServer(nResult);
  _this.setState({ showResult: true,result:{isPass,curPoint:questions.curPoint?questions.curPoint:0,countCorrect,qlength: questions.length,questions} });
}
async postResultToServer(result){
  let doc =  await firebase.firestore().collection("data_agents").doc('data_agents-'+result.idchinhanh).get();
  if(doc.exists)
  {
    let newItem = doc.data();
result.machinhanh = newItem.machinhanh;
result.ten_chinhanh = newItem.ten;
  }
  let res = await STATIC.postFormData(STATIC.API_STUDENT_POSTRESULTCHALLENGE,{result:JSON.stringify(result)});

}

async showRank(){

  let rankLevel = _this.state.rankLevel;
  let orderby = rankLevel+"_point";
  let data =  await firebase.firestore().collection("challenges").doc('challenge').collection('ranks').orderBy(orderby,'desc').get();
  let ranks = [];
  if(data.size>0)
  {
    data.forEach(doc=>{
      let item = doc.data();
      ranks.push(item);
    })
  }
  console.log(ranks);
  _this.setState({showRank:true,ranks});
}


  backClick() {

    if(_this.state.showRank)
   _this.setState({showRank:false});
   else  if(_this.state.showChallenge)
    _this.setState({showChallenge:false});
    else if(_this.state.showType)
    _this.setState({showType:false});
    else if(_this.state.showLevel)
    _this.setState({showLevel:false});

    else
        _this.props.history.push("/");

  }

  onSelectType(type,level)
  {
    let challenge = _this.state.challenge;
    if(!challenge)
    {
      return;
    }

    let curChallenge = challenge[level][type];
    curChallenge.curType = type;
    _this.setState({showChallenge:true,curChallenge});
  }
  selectRankLevel(level)
  {
    _this.setState({rankLevel:level,ranks:[]},()=>_this.showRank())
  }

  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight,showChallenge,showLevel,showType,curType,curLevel,curChallenge,showResult,result,showRank,ranks} = this.state;
    let width = DWIDTH;
    if (wWidth < DWIDTH) {
      width = wWidth;
    }
    let sRate = 640 / 1010;
     if (showChallenge) {
       sRate = 980 / 640;
     }
    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let bRate = 391 / 271;

    let bWidth = width / 2;
    let bWidth2 = width-STATIC.calSize(40, STATIC.DWIDTH, width);

    let video_wrapper = STATIC.calSize(600, STATIC.DWIDTH, width);
    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
    if(showRank)
    {
      let orderby = this.state.rankLevel+"_point";
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <Link to={'/'} style={{ position: "fixed", width: "100%", bottom: 5, left: 5 }}>
            <img src="assets/web/logo_trans.png" style={{ width: STATIC.calSize(189, STATIC.DWIDTH, width), height: "auto" }} />
          </Link>
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

              <div style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{t('common.rank')}</div>
                </div>
                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
              </div>
              <Grid container style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width)}}>
                <Grid xs={4} style={{backgroundColor:_this.state.rankLevel=="easy"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('easy')}>
                    <div style={{ color: 'white', fontSize: fLarge,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >Easy</div>

                </ButtonBase>
                </Grid>
                <Grid xs={4} style={{backgroundColor:_this.state.rankLevel=="medium"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('medium')}>
                    <div style={{ color: 'white', fontSize: fLarge,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >Medium</div>

                </ButtonBase>
                </Grid>
                <Grid xs={4} style={{backgroundColor:_this.state.rankLevel=="hard"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('hard')}>
                    <div style={{ color: 'white', fontSize: fLarge,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >Hard</div>

                </ButtonBase>
                </Grid>

              </Grid>
              <div style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),height:STATIC.calSize(750, STATIC.DWIDTH, width),overflow:'auto'}}>
                {ranks?ranks.map((r,index)=>{

                return (<div
                  key={"r"+index}
                  style={{ width: bWidth2, minHeight: bWidth*0.25,marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), backgroundColor: index<3?'gold':'#8bc53f', display: 'flex',flexDirection:'row' }}>
                    <div style={{borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width),minWidth:bWidth2*0.15,display:'flex',justifyContent:'center',alignItems:'center',backgroundColor:'rgba(0,0,0,0.5)'}}>
                        <div style={{ color: 'white', fontSize: fLarge,textAlign:'center',textTransform:'uppercase' }} >{index+1}</div>
                    </div>
                <div style={{flexGrow:1,paddingLeft:STATIC.calSize(10, STATIC.DWIDTH, width),position:'relative',alignItems:'center'}}>
                  <div style={{ color: 'rgb(5, 63, 34)', fontSize: fLarge,textAlign:'left',width:'100%' }} >{r.name+' - '+r[orderby]}</div>
                  <div style={{ color: 'rgb(5, 63, 34)', fontSize: fNormal,textAlign:'left',width:'100%' }} >{r.machinhanh}</div>
                </div>

              </div>)
            }):<div style={{fontSize:fLarge}}>{t('common.no_result')}</div>}
              </div>



              <Link to="/" style={{ width: '100%' }}>
                <img
                  src="assets/web/logo_green.png"
                  style={{ maxWidth: 296, height: 'auto', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), width: STATIC.calSize(189, STATIC.DWIDTH, width) }} />
              </Link>
            </div>
          </div>
        </div>


      </div>);
    }
    if(showType&&!showChallenge)
    {
      return (
        <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
          <div className={classes.middle}>
            <TopBar width={width} />
              <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>

                </div>
                <Grid container direction='column' alignItems="center" justify="center" >
                  <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.onSelectType('plus',curLevel)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>+/-</div>
                    </ButtonBase>

                  </Grid>
                  <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.onSelectType('multiple',curLevel)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>x</div>
                    </ButtonBase>

                  </Grid>
                  <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.onSelectType('divide',curLevel)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>÷</div>
                    </ButtonBase>

                  </Grid>
                  <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.onSelectType('general',curLevel)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>General</div>
                    </ButtonBase>

                  </Grid>
                  </Grid>

              </div>
            </div>
            <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
              <ButtonBase

                onClick={() => this.backClick()}>
              <img
                src="assets/web/logo_trans.png"
                style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
            </ButtonBase>
            </div>
          </div>
      );
    }
    if(showLevel&&!showChallenge)
    {
      return (
        <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
          <div className={classes.middle}>
            <TopBar width={width} />
              <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>

                </div>
                <Grid container direction='column' alignItems="center" justify="center" >
                  <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({curLevel:'easy',showType:true})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>Easy</div>
                    </ButtonBase>

                  </Grid>
                  <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({curLevel:'medium',showType:true})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>Medium</div>
                    </ButtonBase>

                  </Grid>
                  <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({curLevel:'hard',showType:true})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>Hard</div>
                    </ButtonBase>

                  </Grid>
                  </Grid>

              </div>
            </div>
            <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
              <ButtonBase

                onClick={() => this.backClick()}>
              <img
                src="assets/web/logo_trans.png"
                style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
            </ButtonBase>
            </div>
          </div>
      );
    }
    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <Link to={'/'} style={{ position: "fixed", width: "100%", bottom: 5, left: 5 }}>
            <img src="assets/web/logo_trans.png" style={{ width: STATIC.calSize(189, STATIC.DWIDTH, width), height: "auto" }} />
          </Link>
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

              <div style={{ marginBottom: STATIC.calSize(30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{!showChallenge?t('common.challenges'):curLevel}</div>
                </div>
                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
              </div>

              {!showChallenge?<div style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),height:STATIC.calSize(750, STATIC.DWIDTH, width)}}>
                <Grid container direction="column" alignItems="center" justify="center" >
                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({showLevel:true})} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_challenge_play.png"} style={{ width: bWidth }} />

                    </ButtonBase>

                  </Grid>
                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.showRank()}  focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_challenge_rank.png"} style={{ width: bWidth }} />


                    </ButtonBase>

                  </Grid>




                </Grid>
              </div>:false}
              {showChallenge ? <ChallengeComp
                {...this.state.curChallenge}
                showAdvance={false}
                updateTitle={(title)=>this.setState({title})}
                onLessonEnd={this.onChallengeEnd}
              /> : false}

            </div>
          </div>
        </div>
        <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={true} focusTrapped={false} open={showResult} onClose={() => this.setState({ showResult: false })} center>
          <div style={{ width: width * 0.8, backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
            <div style={{ width: width * 0.8 - STATIC.calSize(10, STATIC.DWIDTH, width) * 2, minHeight: 200, borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), border: '1px solid white', textAlign: 'center' }}>
              <img
                src={result.isPass?"assets/web/icon_soroban_good.png":"assets/web/icon_soroban_bad.png"}
                style={{ width: width * 0.3, height: 'auto', marginTop: STATIC.calSize(-63, STATIC.DWIDTH, width) }} />
              <div style={{ color: 'white', fontSize: width * 0.1, fontWeight: 'bold' }}>
                {result.isPass?"You win":"Game over"}
                              </div>
                              <div style={{ color: 'gold', fontSize: fNormal, fontWeight: 'bold' }}>
                                {result.isPass?t('challenge.your_score'):t('challenge.try_again')}
                                              </div>
                              {result.isPass?<div style={{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}}><div style={{backgroundColor:'yellow',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width),padding:'5px 25px',color: 'rgb(5, 63, 34)', fontSize: fLarge, fontWeight: 'bold'}}>
        {result.curPoint?result.curPoint:0}
      </div></div>:false}


            </div>
          </div>

          <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
            <img
              src="assets/web/logo_green.png"
              style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
          </div>

        </Modal>

      </div>
    );
  }
}


Challenges.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Challenges));
